module.exports = __webpack_public_path__ + "static/offer-design-menu-38324dbdd18c03184ab4f169df5f5c6f.png";